<template>
  <div class="content-main relative">
    <template v-if="openedAlert !== ''">
      <div class="flex justify-center items-center w-full pt-10">
        <button
          class="btn-dark-button absolute right-2 top-2"
          @click="openedAlert = ''"
        >
          Close (Q)
        </button>
        <AlertModal
          :value="openedAlert !== ''"
          @closedAlert="openedAlert = ''"
          :alertId="openedAlert"
        />
      </div>
    </template>
    <template v-else>
      <BaseLeftPageSubMenu
        :menuItems="[]"
        :selectedStatus="filters.statusShipment"
        :searchProp="filters.nkr_code"
        @selectedStatusFilter="updateStatusFilter"
        @searchUpdated="updateSearchFilter"
      >
        <label>Search by nkr code</label>
      </BaseLeftPageSubMenu>
      <div class="content">
        <div class="header relative">
          Alerts from main system
          <button
            v-if="filters.hidden == 0 && alerts.length > 0"
            class="btn-error-button absolute top-2 right-2"
            @click="hideAllAlerts"
          >
            Hide all
          </button>
        </div>
        <div class="flex flex-row navigation">
          <div class="bar">
            <button
              :class="{ active: filters.hidden == 0 }"
              @click="filters.hidden = 0"
            >
              New Alerts
            </button>
            <button
              :class="{ active: filters.hidden == 1 }"
              @click="filters.hidden = 1"
            >
              Hidden only
            </button>
          </div>
        </div>
        <div class="table">
          <AlertsTable
            v-if="alerts.length > 0"
            :filters="filters"
            :alerts="alerts"
            :openedAlert="openedAlert"
            @open="open"
            @hideAlert="hideAlert"
            @unhideAlert="unhideAlert"
          ></AlertsTable>
          <div v-else-if="loading">
            Loading...
          </div>
          <div v-else>
            No alerts found
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  getAlerts,
  hideAlert as hideAlertApi,
  unhideAlert as unhideAlertApi,
  hideAllAlerts as hideAllAlertsApi
} from "@/api/masterAdmin/AlertsService.js";
import AlertModal from "@/components/alerts/AlertModal.vue";
import AlertsTable from "@/components/alerts/AlertsTable.vue";
export default {
  name: "AlertsPage",
  components: {
    AlertModal,
    AlertsTable
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      tableHeaders: [
        {
          displayText: "Date",
          value: "date"
        },
        {
          displayText: "Type",
          value: "type"
        },
        {
          displayText: "nkr code",
          value: "nkrCode"
        },
        {
          displayText: "title",
          value: "title"
        },
        {
          displayText: "Actions",
          value: "actions"
        }
      ],
      filters: {
        nkr_code: "",
        hidden: "0"
        //   page: 1,
        //   limitPerPage: 100,
        //   orderCol: "name",
        //   orderDir: "desc",
        //   search: ""
      },
      loading: true,
      selectedAlert: null,
      openedAlert: "",
      showAlertModal: false,
      alerts: []
    };
  },
  watch: {
    openedAlert() {
      if (!this.loading) {
        const query = {
          ...this.$route.query,
          openedAlert: this.openedAlert
        };
        this.$router.replace({ query }).catch(() => {});
      }
    },
    filters: {
      deep: true,
      handler() {
        console.log("filters changed");
        if (!this.loading) {
          // const query = {
          //   ...this.$route.query,
          //   search: createQueryString(this.filters)
          // };
          // this.$router.replace({ query }).catch(() => {});
          this.loadAlerts();
        }
      }
    }
  },
  computed: {
    arrowDirection() {
      return this.filters.orderDir == "desc" ? "down" : "up";
    }
  },
  mounted() {
    let search = new URLSearchParams(this.$route.query.search);
    if (search) {
      for (let p of search) {
        this.filters[p[0]] = p[1];
      }
    }
    let openedAlert = this.$route.query.openedAlert;
    if (openedAlert && openedAlert != "") {
      console.log(openedAlert);
      this.open(openedAlert);
    }
    this.loading = false;
    this.loadAlerts();
  },
  methods: {
    async hideAllAlerts() {
      if (
        !confirm(
          `Are you sure you want to hide all (${this.alerts.length}) alerts?`
        )
      )
        return;

      try {
        await hideAllAlertsApi();
        this.loadAlerts();
      } catch (error) {
        alert("error hiding all alerts");
      }
    },

    async unhideAlert(id) {
      try {
        await unhideAlertApi(id);
      } catch (error) {
        alert("error unhiding alert");
      }
      const found = this.alerts.find(alert => alert.id == id);
      found.hidden = 0;
    },

    async hideAlert(id) {
      try {
        await hideAlertApi(id);
      } catch (error) {
        alert("error hiding alert");
      }
      const found = this.alerts.find(alert => alert.id == id);
      found.hidden = 1;
    },
    updateSearchFilter(search) {
      this.filters.nkr_code = search;
    },
    updateStatusFilter(status) {
      this.filters.page = 1;
      this.filters.statusShipment = status;
    },
    async loadAlerts() {
      this.loading = true;
      this.alerts = [];
      const res = await getAlerts(this.filters).catch(() => {
        this.$toast.open({
          message: "Error getting alerts",
          type: "Error",
          position: "top-right"
        });
      });
      console.log(res);
      if (res) {
        this.alerts = res;
      }
      this.loading = false;
    },
    changeArrowDir(headerValue) {
      this.filters.page = 1;
      if (headerValue == this.filters.orderCol) {
        this.filters.orderDir =
          this.filters.orderDir == "desc" ? "asc" : "desc";
      } else {
        this.filters.orderCol = headerValue;
        this.filters.orderDir = "desc";
      }
    },
    open(customerID) {
      this.openedAlert = customerID;
      // this.showAlertModal = true;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.content-main {
  .content {
    padding: 5px;
    width: 100%;
    .header {
      width: 100%;
      padding: 20px 15px;
    }
    .table {
      width: 100%;
      height: calc(100% - 200px);
      overflow-x: auto;
    }
    .footer {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      .pages {
        display: flex;
        flex-direction: row;
        div {
          width: 75px;
        }
        .page-link {
          color: $link-color-1;
        }
      }
    }
  }
}
</style>
